import * as React from "react";

import { Banner } from "../banner";
import { DesktopActionBar } from "../desktop-action-bar";
import { MobileActionBar } from "../mobile-action-bar";
import { MobileAppliedFilters } from "../mobile-applied-filters";
import { MobileFilterMenu } from "../mobile-filter-menu";
import { MobileInfoBar } from "../mobile-info-bar";
import { MobileSortingMenu } from "../mobile-sorting-menu";

import { MainContent } from "./main-content";

export const PageResults: React.FunctionComponent = () => {
  return (
    <React.Fragment>
      <Banner />

      <MobileActionBar />
      <MobileAppliedFilters />
      <MobileInfoBar />

      <DesktopActionBar />

      <MobileFilterMenu />
      <MobileSortingMenu />

      <MainContent />
    </React.Fragment>
  );
};
